export default __webpack_public_path__ + "static/media/LOGO-transparent.0c330f7a.png";